module.exports = __webpack_public_path__ + "img/recibos-icon.f5578f36.png";